import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';

const CheckaTradeIcon = (props: IconProps) => (
  <Icon
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 246 205'
    width='auto'
    {...props}
  >
    <path
      fill='#E30713'
      opacity='1.000000'
      stroke='none'
      d=' M1.000000,111.333328   C2.943804,103.914909 4.349133,96.627205 6.925391,89.780083   C17.610287,61.381992 38.469509,46.151260 68.583038,43.898983   C77.007965,43.268856 85.575516,43.554539 94.004250,44.276745   C100.879440,44.865837 107.645172,46.732239 114.803932,48.098011   C113.552650,59.009003 112.365471,69.361038 111.282120,78.807693   C102.854874,77.321068 94.821960,75.187866 86.678795,74.610970   C67.499039,73.252182 51.678043,84.220749 46.225216,102.641380   C40.623528,121.564896 41.320984,140.134644 51.998394,157.418900   C57.051403,165.598572 64.866783,169.935684 73.884033,172.900299   C86.444786,177.029877 97.813034,172.145370 109.493629,169.231155   C111.552109,168.717590 113.528786,167.876099 115.759117,167.112106   C116.236259,177.048080 116.655739,186.667313 117.184151,196.280579   C117.355804,199.403290 115.878670,200.812271 112.959686,201.202530   C103.095711,202.521271 93.236862,203.878448 83.188034,205.610474   C79.969406,206.000000 76.938812,206.000000 73.284332,205.621368   C71.839363,205.156967 71.019936,205.048309 70.196953,204.988678   C36.141224,202.521790 13.070455,183.704468 4.403607,151.201111   C3.066881,146.187988 2.124663,141.069672 1.000000,136.000000   C1.000000,129.645599 1.000000,123.291206 1.282065,116.306213   C1.376086,114.783745 1.188043,113.891869 1.000000,113.000000   C1.000000,112.555557 1.000000,112.111107 1.000000,111.333328  z'
    />
    <path
      fill='#EE8689'
      opacity='1.000000'
      stroke='none'
      d=' M1.000000,113.375000   C1.188043,113.891869 1.376086,114.783745 1.282065,115.837807   C1.000000,115.250000 1.000000,114.500000 1.000000,113.375000  z'
    />
    <path
      fill='#174294'
      opacity='1.000000'
      stroke='none'
      d=' M108.975464,117.986626   C144.553467,71.024414 187.312424,32.945774 239.431244,5.126404   C240.709244,6.773901 241.694763,8.044345 242.893112,9.589152   C237.127716,13.929255 231.252365,17.961487 225.809662,22.511286   C183.315262,58.034264 147.091965,99.020447 118.144371,146.346985   C116.678009,148.744354 114.327782,150.844650 111.940186,152.389435   C104.711197,157.066635 97.261169,161.402222 89.930725,165.850616   C85.194359,153.656723 80.916809,141.306763 75.629196,129.405548   C70.298927,117.408348 64.527771,105.426498 51.886391,98.917610   C58.264080,92.598793 65.595047,88.949463 73.856911,87.270195   C78.347763,86.357399 82.293869,88.285973 84.808929,91.810974   C88.553429,97.059097 91.992973,102.585808 94.972305,108.301498   C97.878433,113.876801 100.043564,119.838356 102.816368,126.287003   C104.913170,123.469574 106.843666,120.875603 108.975464,117.986626  z'
    />
  </Icon>
);

export default CheckaTradeIcon;
